"use strict";

(function (global) {
  var reportPage = {};

  /**
   * Базовый диалог отчетов для вывода ошибок и информационных сообщений.
   */
  reportPage.ReportDialog = WA.CMP.dialogs.MessageBox.extend({
    init() {
      this.ok = WA.CR.window.reload;
      this.setWidth(500);
      this.modal = true;
      this.bind(this.class.EVENT.BEFORE_CLOSE_BY_CROSS, () => {
        WA.CR.window.close();
      });
      this.bind(this.class.EVENT.AFTER_CLOSE_BY_OK, () => {
        WA.CR.window.reload();
      });
    }
  });

  reportPage.getSpinnerDialog = (reportName) => {
    let dialog = new WA.CMP.dialogs.BaseDialog;
    dialog.isShowOkButton = false;
    dialog.width = 'auto';
    dialog.height = 'auto';
    dialog.closeOnEscape = false;

    // Невидимая кнопка для того, чтобы сработал setScope и нельзя было на клавиатуре по странице гулять.
    dialog.modalWindowButtons.push({
      id: 'hiddenButton',
      text: '',
      click: buttonClick = () => { 
        return false; 
      },
      Class: 'dialog_hidden_button'
    });

    dialog.setSpinner(L('PLEASE_WAIT_DONT_CLOSE_PAGE'));
    dialog.setTitle(format(L('PLEASE_WAIT_REPORT'), reportName));

    return dialog;
  }

  /**
   * Отображение модального окна с текстом ошибки.
   * При закрытии окна страница перезагружается.
   * @param {string} text Текст ошибки.
   */
  reportPage.showError = (text) => {
    (new reportPage.ReportDialog).show(
      text,
      null,
      L('ERR'),
      'error',
    );
  };

  /**
   * Отображение диалога завершения генерации отчета.
   */
  reportPage.showFinishDialog = () => {
    (new reportPage.ReportDialog).show(
      L('COMPLETING_WORKING_WITH_REPORT_MESSAGE'),
      null,
      L('COMPLETING_WORKING_WITH_REPORT'),
      'info',
    );
  };

  /**
   * Отображение спиннера.
   */
  reportPage.showSpinner = () => {
    WA.CR.spinner.show();
  };

  /**
   * Скрытие спиннера.
   */
  reportPage.hideSpinner = () => {
    WA.CR.spinner.hide();
  };

  global.reportPage = reportPage;
}(window.Core));

/**
 * Инициализация отчета.
 */
WebAccess.ready(() => {
  if (WA.getLocation() === 'report') {
    // Получение имени и заголовка отчета сделано так из-за
    // того, что ASP .Net добавляет префиксы
    const reportName = $('[id*=_ReportName]').val();

    let report = WA.FC.reports(reportName);
    let spinnerDialog = Core.reportPage.getSpinnerDialog(reportName);

    // Перед непосредственным выполнением отчета нужно начинать крутить спиннер.
    report.bind(report['class'].EVENT.BEFORE_EXECUTING, () => {
      spinnerDialog.show();
    });

    // При показе параметров по кнопке Отмена нужно закрывать текущее окно.
    report.bind(report['class'].EVENT.ABORT_FILLING_PARAMS, () => {
      WA.CR.window.close();
    });

    // Начать выполнение отчета.
    report.queryParamsAndExecute(true, true).always(() => {
      spinnerDialog.close();
    }).done((report) => {
      report.open();
      Core.reportPage.showFinishDialog();
    }).fail((ex) => {
      Core.reportPage.showError(ex);
    });
  }
});
